import React, { useEffect, useRef, createElement } from 'react';
export function ApplicationFormSection() {
  const typeformContainerRef = useRef<HTMLDivElement>(null);
  const scriptLoaded = useRef(false);
  useEffect(() => {
    // Only load the script once
    if (scriptLoaded.current) return;
    // Create and load the Typeform script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    script.onload = () => {
      scriptLoaded.current = true;
      console.log('Typeform script loaded successfully');
    };
    document.body.appendChild(script);
    // Cleanup function to remove the script when component unmounts
    return () => {
      // We don't actually remove the script on unmount as it might be needed by other components
      // and removing it could break the form if it's re-mounted
    };
  }, []);
  return <section id="application-form" className="py-20 bg-gradient-to-br from-purple-600 to-blue-600 text-white" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="max-w-5xl mx-auto relative" data-id="element-111">
          {/* Background elements for visual interest */}
          <div className="absolute -top-6 -left-6 w-20 h-20 bg-purple-400 bg-opacity-20 rounded-full blur-xl" data-id="element-112"></div>
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-blue-400 bg-opacity-20 rounded-full blur-xl" data-id="element-113"></div>
          <div className="relative z-10 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-xl" data-id="element-114">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-115">
              {/* Left content */}
              <div className="w-full md:w-2/5" data-id="element-116">
                <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6" data-id="element-117">
                  <span className="text-xl mr-2" data-id="element-118">🔔</span>
                  <span className="font-medium" data-id="element-119">Limited Spots Available</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-120">
                  Join an Exclusive Research Cohort
                </h2>
                <p className="text-white/90 mb-6" data-id="element-121">
                  Places in our 2025/26 Testbed Schools Programme are limited.
                  We partner with a small cohort of forward-thinking schools to
                  ensure we can provide dedicated support and conduct
                  high-quality research.
                </p>
                <p className="text-white/90 mb-6" data-id="element-122">
                  Complete the short form to express your interest. If your
                  school is a potential fit, we will be in touch to schedule a
                  brief discovery call.
                </p>
                <div className="hidden md:block" data-id="element-123">
                  <div className="flex items-center gap-3 mb-4" data-id="element-124">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg" data-id="element-125">
                      1
                    </div>
                    <p className="font-medium" data-id="element-126">Apply in 2 minutes</p>
                  </div>
                  <div className="flex items-center gap-3 mb-4" data-id="element-127">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg" data-id="element-128">
                      2
                    </div>
                    <p className="font-medium" data-id="element-129">Initial screening call</p>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-130">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg" data-id="element-131">
                      3
                    </div>
                    <p className="font-medium" data-id="element-132">Begin partnership</p>
                  </div>
                </div>
              </div>
              {/* Right content - form */}
              <div className="w-full md:w-3/5 bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-133">
                <div className="p-6 border-b border-gray-200" data-id="element-134">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-135">
                    Application Form
                  </h3>
                  <p className="text-gray-600" data-id="element-136">
                    Tell us about your school and interest in the programme
                  </p>
                </div>
                <div className="p-6 min-h-[400px] bg-gray-50" ref={typeformContainerRef} data-id="element-137">
                  {/* Typeform embed */}
                  <div data-tf-live="01K0443E5E14ERZF0Z4QQEJE86" data-id="element-138"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}